import { render, staticRenderFns } from "./PositionCountersCard.vue?vue&type=template&id=f268b4a6&scoped=true"
import script from "./PositionCountersCard.vue?vue&type=script&lang=js"
export * from "./PositionCountersCard.vue?vue&type=script&lang=js"
import style0 from "./PositionCountersCard.vue?vue&type=style&index=0&id=f268b4a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f268b4a6",
  null
  
)

export default component.exports